/* eslint-disable no-underscore-dangle */
import { API, graphqlOperation, Auth } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api/lib-esm/types';
import { history } from 'index';

export interface ErrorList {
  errors: Array<Error>;
}

enum EndpointsNames {
  Default = 'default',
  Admin = 'admin',
}

let isRedirectingToMaintenance = false;

const isMaintenanceModeError = (error: any): boolean => {
  if (!error?.errors || !Array.isArray(error.errors)) {
    return false;
  }
  return error.errors.some(
    (e: any) => e.errorType === 'MAINTENANCE_MODE'
  );
};

const handleMaintenanceMode = async (): Promise<never> => {
  if (isRedirectingToMaintenance) {
    return new Promise<never>(() => {});
  }
  isRedirectingToMaintenance = true;

  try {
    await Auth.signOut();
  } catch {
    // Proceed even if sign-out fails
  }

  localStorage.clear();
  history.push('/maintenance');

  return new Promise<never>(() => {});
};

export const resetMaintenanceRedirectFlag = (): void => {
  isRedirectingToMaintenance = false;
};

const findSetting = (settingName: string) => {
  return (API as any)._options.API.endpoints.find((x: any) => x.name === settingName).endpoint;
};

const makeRequest = async (query: string, data?: object) => {
  try {
    return (await API.graphql(graphqlOperation(query, data))) as GraphQLResult;
  } catch (error) {
    if (isMaintenanceModeError(error)) {
      return handleMaintenanceMode();
    }
    throw error;
  }
};

const makeDefaultRequest = async (query: string, data?: object) => {
  (API as any)._graphqlApi._options.aws_appsync_graphqlEndpoint = findSetting(EndpointsNames.Default);
  return makeRequest(query, data);
};

export const makeAdminRequest = async (query: string, data?: object) => {
  (API as any)._graphqlApi._options.aws_appsync_graphqlEndpoint = findSetting(EndpointsNames.Admin);
  return makeRequest(query, data);
};

export default makeDefaultRequest;
/* eslint-disable no-underscore-dangle */
